import { render, staticRenderFns } from "./HrvExamination.vue?vue&type=template&id=21a519d9&"
import script from "./HrvExamination.vue?vue&type=script&lang=ts&"
export * from "./HrvExamination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports